export const PROMOTION_BTN_TYPE = {
  LINK: 'link',
  BASKET: 'basket'
};
